import { render, staticRenderFns } from "./smoke-warning.vue?vue&type=template&id=5c46433c&scoped=true&"
import script from "./smoke-warning.vue?vue&type=script&lang=js&"
export * from "./smoke-warning.vue?vue&type=script&lang=js&"
import style0 from "./smoke-warning.vue?vue&type=style&index=0&id=5c46433c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c46433c",
  null
  
)

export default component.exports